import { api } from '@/helpers/api'
import { useValidation } from '@/composables/utils/useValidation'

import useNotification from '@/composables/useNotification.js'

const URLS = {
    xhr: {
        mutate: {
            isUser: '/api/profile/is-user'
        }
    }
}

export const useDirectBookingWelcome = (currentStep, userData, load) => {
    const { isValid } = useValidation()
    const { notification } = useNotification()

    async function isUser(v) {
        if (isValid(v)) {
            try {
                load.value = true
                const data = await api({
                    method: 'post',
                    url: URLS.xhr.mutate.isUser,
                    data: userData.value.welcome
                })
                return _postWelcomeStep(data)
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Email not valid.')
        }
    }
    function _postWelcomeStep(data) {
        if (data?.user.first_name) {
            userData.value.name = data.user.first_name

            return true
        } else {
            return false
        }
    }

    return {
        isUser
    }
}
